var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      ref: "modal",
      attrs: { bgcolor: "rgba(0,0,0,0.3)" },
      on: { closed: _vm.onClosed },
    },
    [
      _c("div", { staticClass: "profile-modal" }, [
        _c("i", { staticClass: "isif isif-close", on: { click: _vm.hide } }),
        _vm._v(" "),
        _c("div", { staticClass: "profile-modal-inner" }, [
          _c("div", { staticClass: "profile-modal-portrait" }, [
            _c("div", { staticClass: "profile-modal-portrait-inner" }, [
              _vm.customBranding
                ? _c("div", { staticClass: "profile-modal-portrait-user" }, [
                    _vm.portrait
                      ? _c("img", { attrs: { src: _vm.portrait } })
                      : _c("i", { staticClass: "isif isif-man" }),
                  ])
                : _c("img", {
                    staticClass: "profile-modal-portrait-istaging",
                    attrs: { src: _vm.iStagingPortrait },
                  }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-modal-name" }, [
            _c("span", [_vm._v(_vm._s(_vm.name))]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "profile-modal-detail" }, [
            _vm.companyDisplayName
              ? _c("li", [
                  _c("i", { staticClass: "isif isif-brief-case" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.companyDisplayName))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.phone
              ? _c("li", [
                  _c("i", { staticClass: "isif isif-phone" }),
                  _vm._v(" "),
                  _c("a", { attrs: { href: `tel:${_vm.phone}` } }, [
                    _vm._v(_vm._s(_vm.phone)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayEmail
              ? _c("li", [
                  _c("i", { staticClass: "isif isif-drawer" }),
                  _vm._v(" "),
                  _vm.email
                    ? _c("a", {
                        attrs: {
                          href: `mailto:${_vm.email}`,
                          target: "_blank",
                        },
                        domProps: { textContent: _vm._s(_vm.email) },
                      })
                    : _c("span", {
                        domProps: { textContent: _vm._s(_vm.$t("None")) },
                      }),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }